import React from 'react'
import { Divider, Button, Link } from '@mui/material'
import { createTheme, ThemeProvider } from "@mui/material/styles";
import VolunteerActivismIcon from '@mui/icons-material/VolunteerActivism';

const theme = createTheme({
  palette: {
    primary: {
      main: "#99aab5", // custom primary color
    },
    secondary: {
      main: "#F27920", // custom secondary color
    },
  },
});

export default function BecomeAMember() {
  return (
    <div className='bg-white p-20'>
      <div><h1 className='text-2xl font-bold text-[#F27920] pb-5'>Membership</h1></div>

      <Divider className='' />
      <div className='mt-5'><div>Since 1987, the National Save The Sea Turtle Foundation has worked tirelessly to provide educational programming, promote public awareness, and support sea turtle research in the U.S. and abroad. Your contribution is critical to our continued success. Thank you!</div></div>


      <div className='mt-5 gap-5'>

        <div className='text-center my-8'>
          <ThemeProvider theme={theme}>
            <Link href='/Forms/Member50.html' target='_blank' rel='noopener noreferrer' title='Individual Membership'>

              <Button color="secondary" variant="contained" fullWidth style={{ color: '#ffffff' }}>

                <div>
                  <div className='text-center'><VolunteerActivismIcon fontSize='large' /></div>
                  <div className='text-2xl font-bold text-center py-2' >$50.00</div>
                  <div className='text-center'>Individual Membership</div>
                </div>

              </Button>
            </Link>

          </ThemeProvider>
        </div>

      </div>


      <div className='gap-5'>
        <div className='text-center my-8'>
          <ThemeProvider theme={theme}>
            <Link href='/Forms/Member100.html' target='_blank' rel='noopener noreferrer' title='Sponsor Membership'>

              <Button color="secondary" variant="contained" fullWidth style={{ color: '#ffffff' }}>

                <div>
                  <div className='text-center'><VolunteerActivismIcon fontSize='large' /></div>
                  <div className='text-2xl font-bold text-center py-2' >$100.00</div>
                  <div className='text-center'>Sponsor Membership</div>
                </div>

              </Button>
            </Link>

          </ThemeProvider>
        </div>


      </div>

      <div>
        <div className='text-center my-8'>
          <ThemeProvider theme={theme}>
            <Link href='/Forms/Member300.html' target='_blank' rel='noopener noreferrer' title='Business Membership'>

              <Button color="secondary" variant="contained" fullWidth style={{ color: '#ffffff' }}>

                <div>
                  <div className='text-center'><VolunteerActivismIcon fontSize='large' /></div>
                  <div className='text-2xl font-bold text-center py-2' >$300.00</div>
                  <div className='text-center'>Business Membership</div>
                </div>

              </Button>
            </Link>

          </ThemeProvider>
        </div>
      </div>


      <div className='gap-5'>
        <div className='text-center my-8'>
          <ThemeProvider theme={theme}>
            <Link href='/Forms/Member500.html' target='_blank' rel='noopener noreferrer' title='Patron Membership'>

              <Button color="secondary" variant="contained" fullWidth style={{ color: '#ffffff' }}>

                <div>
                  <div className='text-center'><VolunteerActivismIcon fontSize='large' /></div>
                  <div className='text-2xl font-bold text-center py-2' >$500.00</div>
                  <div className='text-center'>Patron Membership</div>
                </div>

              </Button>
            </Link>

          </ThemeProvider>
        </div>

      </div>


      <div className='gap-5'>
        <div className='text-center my-8'>
          <ThemeProvider theme={theme}>
            <Link href='/Forms/Member1000.html' target='_blank' rel='noopener noreferrer' title='Associate Membership'>

              <Button color="secondary" variant="contained" fullWidth style={{ color: '#ffffff' }}>

                <div>
                  <div className='text-center'><VolunteerActivismIcon fontSize='large' /></div>
                  <div className='text-2xl font-bold text-center py-2' >$1000.00</div>
                  <div className='text-center'>Associate Membership</div>
                </div>

              </Button>
            </Link>

          </ThemeProvider>
        </div>


      </div>


      <div className='gap-5'>
        <div className='text-center my-3'>
          <ThemeProvider theme={theme}>
            <Link href='/Forms/Member5000.html' target='_blank' rel='noopener noreferrer' title='Elite Sponsor Membership'>

              <Button color="secondary" variant="contained" fullWidth style={{ color: '#ffffff' }}>

                <div>
                  <div className='text-center'><VolunteerActivismIcon fontSize='large' /></div>
                  <div className='text-2xl font-bold text-center py-2 ' >$5000.00</div>
                  <div className='text-center'>Elite Sponsor Membership</div>
                </div>

              </Button>
            </Link>

          </ThemeProvider>
        </div>


      </div>
    </div >
  )
}
